module.exports = __webpack_public_path__ + "img/alv_logo_vector.275bd3e7.svg";